import React from 'react';
import { ArticleBody } from './ArticleBody';
import { printProHeadlineArticleContent } from '@benzinga/article-manager';
import { BenzingaProLogo } from '@benzinga/logos-ui';
import styles from './ArticleHeadlineContent.module.scss';
import { Button } from '@benzinga/core-ui';
import { Impression } from '@benzinga/analytics';
// import { YoutubeBlock } from '@benzinga/money';

const features = [
  'The most trusted brand in stock market news',
  'Fatest intelligence & alerts',
  'Active trader chat rooms',
  'Option trade alerts',
  'Only comprehensive mobile notifications solution',
  'Welcoming & white glove support',
];

export const ArticleHeadlineContent = () => {
  return (
    <div className={styles.container}>
      <ArticleBody body={printProHeadlineArticleContent()} />
      {/* <YoutubeBlock videoId="HfE5b6NxUis" /> */}
      <Impression campaign_id="bzheadline" unit_type="newsdeskheadline-page-ad">
        <a
          className="benzinga-pro-ad-box"
          href="https://pro.benzinga.com/register/?utm_source=bzheadline"
          rel="noreferrer"
          target="_blank"
        >
          <BenzingaProLogo />
          <ul className="features-list">
            {features.map(feature => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
          <Button variant="flat-blue">Active My Free Trial</Button>
        </a>
      </Impression>
    </div>
  );
};
